<!-- 草稿 -->
<template>
	<div class="box-page" v-loading="loading">
		<div class="flex-c-s box-title-line">
			<div class="box-title" style="width: 85px">我的草稿</div>
		</div>
		<el-table :data="list" class="mt20">
			<el-table-column prop="tag" width="100">
				<template>
					<el-tag type="warning" disable-transitions>草稿</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="questionSystem" label="问题系统" min-width="150">
			</el-table-column>
			<el-table-column prop="contactUserName" label="联系人" min-width="120">
			</el-table-column>
			<el-table-column prop="contactTel" label="联系电话" show-overflow-tooltip min-width="120">
			</el-table-column>
			<el-table-column prop="hopeCompleteTime" label="期望完成时间" show-overflow-tooltip min-width="120">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="120">
			</el-table-column>
			<el-table-column fixed="right" label="操作" width="100">
				<template slot-scope="scope">
					<el-button @click="handleView(scope.row)" style="margin-right: 10px;" type="text" size="small">查看
					</el-button>
					<el-popconfirm title="您确定删除该草稿吗？" @confirm="deleteDraft(scope.row.sheetDraftId)">
						<el-button slot="reference" type="text" size="small" style="color: #F56C6C;">
							删除</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
			@current-change="getList" class="box-paging">
		</el-pagination>

		<AddOrder :showDraft="false" showEditDraft @refresh="refresh" ref="addOrder" />
	</div>
</template>

<script>
	import AddOrder from '@/components/WorkOrder/AddOrder'

	export default {
		components: {
			AddOrder
		},
		data() {
			return {
				loading: false,
				list: [],
				page: 1,
				total: 1,
				draftId: '' // 当前查看的草稿id
			}
		},
		mounted() {
			this.getList()
		},
		methods: {
			/** 获取草稿列表 */
			async getList() {
				this.loading = true
				try {
					const {
						data
					} = await this.$api.order.sheetDraftList({
						page: this.page,
						limit: 10
					})
					if (data.code === 200) {
						this.list = data.data
						this.total = data.total
					}
				} finally {
					this.loading = false
				}
			},

			/** 打开查看 */
			handleView(item) {
				this.draftId = item.sheetDraftId
				this.$refs.addOrder.open(item)
			},

			/** 草稿发布 or 修改 */
			async refresh(type) {
				type === '1' ? this.deleteDraft(this.draftId) : this.getList()
			},

			/** 删除草稿 */
			async deleteDraft(id) {
				this.loading = true
				try {
					const {
						data
					} = await this.$api.order.deleteSheetDraft(id)
					if (data.code === 200) this.getList()
				} finally {
					this.loading = false
				}
			}
		}
	}
</script>

<style scoped lang="scss">
</style>
